import React from 'react'
import { Outlet } from 'react-router-dom'
import { useNavigate, useLocation, Navigate } from 'react-router-dom'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { FaServer } from 'react-icons/fa'


const TABS = [
  { name: 'Статус серверов', path: '/dashboard/servers', },
  { name: 'Резервное копирование', path: '/dashboard/backup' },
  { name: 'Обмен консолидированной отчетностью', path: '/dashboard/exchange' },
  { name: 'Обмен файлами', path: '/dashboard/fileexchange' },
]

const Main = () => {

  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { loading } = useSelector(state => state.dashboard)

  const renderTab = ({ name, path, icon: Icon }) => {

    const classNames = cn({
      [styles.active]: path === pathname,
      [styles.disabled]: loading
    })

    return (
      <li
        onClick={() => navigate(path, { replace: true })}
        className={classNames}
      >
        {Icon && <Icon size={20} className={styles.tabIcon} />}
        {name}
      </li>
    )
  }

  if (pathname === '/dashboard') return <Navigate to='/dashboard/servers' replace />;

  return (
    <div className={styles.wrapper}>
      <nav>
        <ul>
          {TABS.map(renderTab)}
        </ul>
      </nav>
      <Outlet />
    </div>
  )
}

export default Main